import { render, staticRenderFns } from "./ReportContentItem.vue?vue&type=template&id=19391c92&scoped=true&"
import script from "./ReportContentItem.vue?vue&type=script&lang=js&"
export * from "./ReportContentItem.vue?vue&type=script&lang=js&"
import style0 from "./ReportContentItem.vue?vue&type=style&index=0&id=19391c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19391c92",
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QIcon,QItem} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItemSection,QIcon,QItem}, component.options.components || {})
